import { render, staticRenderFns } from "./StreamTitle.vue?vue&type=template&id=48820580&scoped=true&"
import script from "./StreamTitle.vue?vue&type=script&lang=js&"
export * from "./StreamTitle.vue?vue&type=script&lang=js&"
import style0 from "./StreamTitle.vue?vue&type=style&index=0&id=48820580&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48820580",
  null
  
)

export default component.exports